import {
    InputAdornment, List, ListItem, ListItemText, TextField,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import store from 'store';
import React from 'react';
import { connect } from 'react-redux';
import { Number, Progress } from 'components';

const propTypes = {
    onRowClicked: PropTypes.func.isRequired,
};
const defaultProps = {};

const { select } = store;

const mapStateToProps = ({ loading }) => ({
    items: select.packages.all(store.getState()),
    fetching: loading.effects.packages.fetch,
});

const mapDispatchProps = ({ packages }) => ({
    fetch: (params) => packages.fetch(params),
});

const reduxConnector = connect(mapStateToProps, mapDispatchProps);

function PackageSearch(props) {
    const { items, fetching, onRowClicked } = props;

    function handleSearch(e) {
        const { fetch } = props;
        const { value } = e.target;

        if (value.length < 3) {
            return;
        }

        fetch({ search: value, count: 25 });
    }

    return (
        <div>
            <TextField
                margin="dense"
                variant="filled"
                fullWidth
                placeholder="Start typing to search and click on result to select package"
                onChange={handleSearch}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {fetching ? <Progress size={24} /> : <SearchIcon />}
                        </InputAdornment>
                    ),
                }}
            />

            <div style={{ maxHeight: 400, overflowY: 'scroll' }}>
                <List dense>
                    {items.map((item) => (
                        <ListItem divider button key={item.id} onClick={() => onRowClicked(item)}>
                            <ListItemText
                                primary={(
                                    <>
                                        <Number
                                            prefix
                                            preText={item.name}
                                            value={item.selling_price}
                                            typographyProps={{ variant: 'subtitle2' }}
                                        />
                                    </>
                                )}
                            />
                        </ListItem>
                    ))}
                </List>
            </div>
        </div>
    );
}

PackageSearch.propTypes = propTypes;
PackageSearch.defaultProps = defaultProps;

export default reduxConnector(PackageSearch);
